export default "__VITE_ASSET__fb2dcc86__"